import type { ReactNode } from "react";

import { cn } from "@/lib/utils";

interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  description?: ReactNode;
  centered?: boolean;
  fullWidthDescription?: boolean;
  titleClassName?: string;
}

export function SectionHeading({
  title,
  description,
  centered = false,
  fullWidthDescription = false,
  titleClassName,
}: SectionHeadingProps) {
  return (
    <div className={cn("space-y-4", centered && "mx-auto max-w-3xl text-center")}>
      <h2
        className={cn(
          "text-3xl font-semibold tracking-[-0.06em] text-balance md:text-5xl",
          titleClassName
        )}
      >
        {title}
      </h2>
      {description ? (
        <div
          className={cn(
            "text-base leading-8 text-muted-foreground md:text-lg",
            !fullWidthDescription && "max-w-3xl"
          )}
        >
          {typeof description === "string" ? <p>{description}</p> : description}
        </div>
      ) : null}
    </div>
  );
}
